<div class="tab-wrapper mb-5">
  <div class="row">
    <div class="col-lg-12">
      <div
        *ngIf="authService.canRead('employee_direct_deposit_panel') && ddForm != null"
        [formGroup]="ddForm">
        <div class="row mb-3">
          <div class="col-4">
            <h3 class="card-title fw-bold">Active Accounts</h3>
          </div>
          <div class="col-4">
            <small *ngIf="isEmployeePortal && !hasOpenRequest && !activeRecordControls.invalid"
              >*Changes require approval</small
            >
            <small *ngIf="isEmployeePortal && hasOpenRequest" class="text-cp-green"
              >*Changes pending approval.</small
            >
            <div *ngIf="activeRecordControls.invalid && ddForm.dirty">
              <small
                class="form-text text-danger"
                *ngIf="activeRecordControls.errors?.['AllocationExceeded']">
                *Total amount is over 100%
              </small>
              <small
                class="form-text text-danger"
                *ngIf="activeRecordControls.errors?.['MultipleNetRemaining']">
                *You may only have 1 record set to NetRemaining
              </small>
            </div>
            <small
              class="form-text text-danger d-block"
              *ngIf="
                percentOfNetTotal === 100 &&
                countOfNetRemaining > 0 &&
                activeRecordControls.length > 0
              ">
              Warning: You have allocated 100% of net, and you have an account set to 'Net
              Remaining'. The 'Net Remaining' account will not be used. Please revise the account
              distribution.
            </small>
            <small
              class="form-text text-danger d-block"
              *ngIf="
                percentOfNetTotal < 100 &&
                countOfNetRemaining == 0 &&
                activeRecordControls.length > 0
              ">
              Warning: You have not allocated 100% of net, and you do not have an account set to
              'Net Remaining'. You may receive a paper check.
            </small>
          </div>
          <div class="col-4 text-end">
            <div *ngIf="!hasOpenRequest && !ddForm.pristine && !formIsUnchanged">
              <button class="btn btn-secondary" (click)="cancelChanges()">Cancel</button>
              <button
                [disabled]="ddForm.invalid || (readOnly | async)"
                class="btn btn-primary ms-3"
                (click)="preSubmissionChecks()">
                Save & Submit
              </button>
            </div>
            <div *ngIf="hasOpenRequest">
              <button class="btn btn-primary ms-3" (click)="openModal()">Review Change</button>
            </div>
          </div>
        </div>
        <div *ngIf="activeRecordControls.length == 0 && disabledRecordControls.length == 0">
          <br />
          <em
            >No Bank Accounts.
            <span *ngIf="hasOpenRequest">There are changes pending approval.</span>
          </em>
        </div>
        <table
          class="table table-connectpay bg-white"
          [class.mb-5]="disabledRecordControls.length === 0">
          <thead>
            <tr>
              <th>Bank</th>
              <th>Routing</th>
              <th>Account</th>
              <th>Account Type</th>
              <th>Amount Type</th>
              <th>Amount</th>
              <th></th>
            </tr>
          </thead>
          <tbody formArrayName="enabledAccounts">
            <tr
              *ngFor="let item of activeRecordControls.controls; let i = index"
              [formGroupName]="i">
              <td>{{ item.get('bankName').value }}</td>
              <td>
                <span *ngIf="item.get('id').value != null">
                  ***{{
                    item
                      .get('routingNumber')
                      .value.slice(
                        item.get('routingNumber').value.length - 4,
                        item.get('routingNumber').value.length
                      )
                  }}
                </span>
                <div *ngIf="item.get('id').value == null">
                  <div *hasPermission="'employee_direct_deposit_routing_number'">
                    <input
                      class="form-control mb-0"
                      formControlName="routingNumber"
                      placeholder="Enter Routing #"
                      maxlength="9"
                      minlength="9" />
                    <div
                      class="mt-1"
                      *ngIf="
                        item.get('routingNumber').invalid && item.get('routingNumber').touched
                      ">
                      <small
                        class="form-text text-danger"
                        *ngIf="item.get('routingNumber').errors?.['required']"
                        >Routing Number is required.</small
                      >
                      <small
                        class="form-text text-danger"
                        *ngIf="item.get('routingNumber').errors?.['minlength']"
                        >Invalid Routing Number.</small
                      >
                      <small
                        class="form-text text-danger"
                        *ngIf="item.get('routingNumber').errors?.['maxlength']"
                        >Invalid Routing Number.</small
                      >
                      <small
                        class="form-text text-danger"
                        *ngIf="item.get('routingNumber').errors?.['invalidBank']"
                        >Routing Number entered not found.</small
                      >
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <span *ngIf="item.get('id').value != null">
                  {{ item.get('accountNumber').value }}
                </span>
                <div *ngIf="item.get('id').value == null">
                  <div *hasPermission="'employee_direct_deposit_account_number'">
                    <input
                      class="form-control mb-0"
                      formControlName="accountNumber"
                      [hiddenInput]="item.get('accountNumberMask').value"
                      (blur)="blurAcctNo(i)"
                      mask="XXXXXXXXXXXXXXXXX"
                      [validation]="false"
                      placeholder="Enter Account #" />
                    <input
                      *ngIf="item.get('accountNumber').dirty"
                      class="form-control mb-0 mt-1"
                      mask="XXXXXXXXXXXXXXXXX"
                      (blur)="blurAcctNoMatch(i)"
                      [validation]="false"
                      [hiddenInput]="item.get('accountNumberMatchMask').value"
                      formControlName="accountNumberMatch"
                      placeholder="Confirm Account #" />
                    <div
                      class="mt-1"
                      *ngIf="
                        item.get('accountNumber').invalid && item.get('accountNumber').touched
                      ">
                      <small
                        class="form-text text-danger"
                        *ngIf="item.get('accountNumber').errors?.['required']"
                        >Account Number is required.</small
                      >
                    </div>
                    <ng-container
                      *ngIf="
                        item.invalid &&
                        item.errors?.AccountNumberMatch &&
                        item.get('accountNumber').dirty &&
                        item.get('accountNumberMatch').dirty
                      ">
                      <small class="form-text text-danger mt-1"
                        >Account Numbers do not match.</small
                      >
                    </ng-container>
                  </div>
                </div>
              </td>
              <td>
                <span *ngIf="item.get('id').value != null">
                  <span *ngIf="item.get('accountType').value == '0'">Checking</span>
                  <span *ngIf="item.get('accountType').value == '1'">Savings</span>
                  <span *ngIf="item.get('accountType').value == '2'">IRA</span>
                </span>
                <div *ngIf="item.get('id').value == null">
                  <div *hasPermission="'employee_direct_deposit_account_type'">
                    <select formControlName="accountType" class="form-control mb-0">
                      <option [ngValue]="null" disabled></option>
                      <option [ngValue]="0">Checking</option>
                      <option [ngValue]="1">Savings</option>
                      <option [ngValue]="2">IRA</option>
                    </select>
                    <div
                      class="mt-1"
                      *ngIf="item.get('accountType').invalid && item.get('accountType').touched">
                      <small
                        class="form-text text-danger"
                        *ngIf="item.get('accountType').errors?.['required']"
                        >Account Type is required.</small
                      >
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div *hasPermission="'employee_direct_deposit_calcuation_method'">
                  <fieldset [disabled]="(readOnly | async) || hasOpenRequest">
                    <select class="form-control mb-0" formControlName="amountType">
                      <option [ngValue]="null" disabled></option>
                      <option [ngValue]="0">Dollar</option>
                      <option [ngValue]="1">% of Net</option>
                      <option [ngValue]="2">Remaining</option>
                    </select>
                  </fieldset>
                </div>
              </td>
              <td>
                <div *ngIf="item.get('amountType').value != 2">
                  <fieldset [disabled]="(readOnly | async) || hasOpenRequest">
                    <div class="input-group mb-0" *hasPermission="'employee_direct_deposit_amount'">
                      <div *ngIf="item.get('amountType').value == 0" class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input
                        class="form-control mb-0 d-inline-block"
                        formControlName="amount"
                        type="number" />
                      <div *ngIf="item.get('amountType').value == 1" class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </td>
              <td>
                <div *hasPermission="'employee_direct_deposit_disabled'">
                  <button
                    *ngIf="item.get('id').value != null"
                    [disabled]="(readOnly | async) || hasOpenRequest"
                    class="btn btn-tertiary"
                    style="padding: 12px 22px"
                    (click)="disableAccount(item, i)">
                    Deactivate
                  </button>
                  <button
                    *ngIf="item.get('id').value == null"
                    [disabled]="(readOnly | async) || hasOpenRequest"
                    class="btn btn-danger-tertiary border-0"
                    style="padding: 12px 22px"
                    (click)="disableAccount(item, i)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="7" class="p-0 text-center">
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'people_edit_add_direct_deposit_account' }"
                  appAutoFocus
                  type="button"
                  class="btn btn-primary"
                  style="padding: 12px 22px"
                  (click)="addNewAccount()"
                  [disabled]="(readOnly | async) || hasOpenRequest">
                  <i class="fas fa-xs fa-plus"></i>&nbsp;Add New Account
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-container *ngIf="disabledRecordControls.length > 0">
          <div class="row mt-3">
            <div class="col-9">
              <h3 class="card-title fw-bold">Inactive Accounts</h3>
            </div>
          </div>
          <table class="table table-connectpay bg-white">
            <thead>
              <tr>
                <th>Bank</th>
                <th>Routing</th>
                <th>Account</th>
                <th>Account Type</th>
                <th>Amount Type</th>
                <th>Amount</th>
                <th></th>
              </tr>
            </thead>
            <tbody formArrayName="disabledAccounts">
              <tr
                *ngFor="let item of disabledRecordControls.controls; let i = index"
                [formGroupName]="i">
                <td>{{ item.get('bankName').value }}</td>
                <td>
                  ***{{
                    item
                      .get('routingNumber')
                      .value.slice(
                        item.get('routingNumber').value.length - 4,
                        item.get('routingNumber').value.length
                      )
                  }}
                </td>
                <td>{{ item.get('accountNumber').value }}</td>
                <td>
                  <span *ngIf="item.get('accountType').value == '0'">Checking</span>
                  <span *ngIf="item.get('accountType').value == '1'">Savings</span>
                  <span *ngIf="item.get('accountType').value == '2'">IRA</span>
                </td>
                <td>
                  <span *ngIf="item.get('amountType').value == 0">Dollar</span>
                  <span *ngIf="item.get('amountType').value == 1">% of Net</span>
                  <span *ngIf="item.get('amountType').value == 2">Remaining</span>
                </td>
                <td>
                  <span *ngIf="item.get('amountType').value == 1"
                    >{{ item.get('amount').value }}%</span
                  >
                  <span *ngIf="item.get('amountType').value == 0"
                    >${{ item.get('amount').value }}</span
                  >
                  <span *ngIf="item.get('amountType').value == 2"></span>
                </td>
                <td>
                  <div class="row">
                    <div class="col-6">
                      <div *hasPermission="'employee_direct_deposit_disabled'">
                        <button
                          [disabled]="(readOnly | async) || hasOpenRequest"
                          class="btn btn-tertiary"
                          style="padding: 12px 22px"
                          (click)="enableAccount(item, i)">
                          Activate
                        </button>
                      </div>
                    </div>
                    <div class="col-6 d-flex flex-column justify-content-center">
                      <span *ngIf="item.get('deactivated').value" class="badge bg-warning"
                        >Pending</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<lib-direct-deposit-change-review-modal
  *ngIf="openRequest != null && openRequestData != null"
  [changeRequest]="openRequest"
  [changeRequestData]="openRequestData"
  (modalClosed)="closeModal()"
  (cancelChange)="modalCancelRequest()"
  [allowDecision]="!isEmployeePortal"></lib-direct-deposit-change-review-modal>
<lib-direct-deposit-disclaimer-modal
  *ngIf="showDisclaimerModal"
  (submit)="disclaimerClosed($event)"></lib-direct-deposit-disclaimer-modal>
